import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import ConfirmModal from "../utilities/ConfirmModal";
import moment from "moment";
import * as FaIcons from "react-icons/fa";
import ExportPdfButton from "./ExportPdfButton";
import AdminLeloContext from "../../context/adminLelo/adminLeloContext";
import AuthContext from "../../context/auth/authContext";
import { getAppUrl } from "../../functions/getEnv";
import axios from "axios";
import setAuthToken from "../../functions/auth_header";
import { BlobServiceClient } from "@azure/storage-blob";
import { PDFDocument } from "pdf-lib";
import { toast } from "react-toastify";

const blobEndpoint = import.meta.env.VITE_BLOB_ENDPOINT;
const blobContainer = import.meta.env.VITE_BLOB_CONTAINER;

const blobSas = import.meta.env.VITE_BLOB_SAS;

const LeloForm = ({ formData }) => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);

  const adminLeloContext = useContext(AdminLeloContext);
  const { updateLeloEntrie, getLeloSession, leloSession } = adminLeloContext;
  const {
    _id,
    charter,
    charter_id,
    status,
    hasPreviouslyEnrolled,
    firstName,
    middleName,
    lastName,
    gender,
    birthDate,
    studentEmail,
    studentPrimaryPhone,
    studentPrimaryPhoneType,
    pgFirstName,
    pgLastName,
    pgRelationshipToStudent,
    pgPrimaryEmail,
    pgPrimaryPhone,
    pgPrimaryPhoneType,
    liveWithPg,
    livingStatus,
    street,
    city,
    state,
    zip,
    country,
    district,
    isMailingAddressTheSame,
    mailingStreet,
    mailingCity,
    mailingState,
    mailingZip,
    gradeLevel,
    courses = [],
    selectedCourseAgreements = [],
    studentSignature,
    studentName,
    studentSignatureDate,
    parentSignature,
    parentName,
    parentSignatureDate,
    learningCenters,
    uploadedUrl,
    uploadedPdfs,
    _uuid,
  } = formData;

  const [showInactiveModal, setShowInactiveModal] = useState(false);
  const [res1, setRes] = useState("");

  const handleEditInterest = (_id) => {
    navigate(`/editLeloForm/${_id}`);
  };

  const handleNotActive = () => {
    const updatedData = {
      status: "Inactive",
    };
    updateLeloEntrie(_id, updatedData);
    navigate("/lelo-forms");
  };

  const handleCloseModal = () => {
    setShowInactiveModal(false);
  };
  useEffect(() => {
    getLeloSession(formData.permaLink);
  }, []);

  
  const sanitize = (str) => {
    if (!str) return "";
    return String(str).replace(/[^a-zA-Z0-9]/g, "");
  };

  const formatTimestamp = () => {
    const date = new Date();
    const year = String(date.getFullYear()).slice(-2);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}${month}${day}_${hours}${minutes}`;
  };

  useEffect(() => {
    if (Array.isArray(leloSession?.data) && leloSession.data.length > 0) {
      const sessionData = leloSession.data[0];
      const startDates = sessionData.schoolYearStartDate;
      const endDates = sessionData.schoolYearEndDate;

      if (Array.isArray(startDates) && Array.isArray(endDates) && startDates.length > 0) {
        // Display all date ranges
        const dateRanges = startDates.map((start, index) => {
          const [yearStart, monthStart, dayStart] = start.date.split("-");
          const formattedStart = `${monthStart}-${dayStart}-${yearStart}`;

          const [yearEnd, monthEnd, dayEnd] = endDates[index].date.split("-");
          const formattedEnd = `${monthEnd}-${dayEnd}-${yearEnd}`;

          return `${formattedStart} to ${formattedEnd}`;
        }).join("; ");

        setRes(dateRanges);
      } else if (typeof startDates === "string" && typeof endDates === "string") {
        // Old format (backward compatibility)
        const [yearStart, monthStart, dayStart] = startDates.split("-");
        const formattedStart = `${monthStart}-${dayStart}-${yearStart}`;

        const [yearEnd, monthEnd, dayEnd] = endDates.split("-");
        const formattedEnd = `${monthEnd}-${dayEnd}-${yearEnd}`;

        setRes(`${formattedStart} to ${formattedEnd}`);
      }
    } else {
      console.warn("leloSession data is not available or empty.");
    }
  }, [leloSession]);

  const handleRegeneratePdf = async () => {
    try {
      // Disable the button while processing
      const regenerateButton = document.querySelector(".btn-llac-dark-green");
      if (regenerateButton) {
        regenerateButton.disabled = true;
        regenerateButton.style.opacity = "0.5";
      }

      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }

      // Get session data
      if (!leloSession?.data || !Array.isArray(leloSession.data) || leloSession.data.length === 0) {
        throw new Error("Session data is not available");
      }

      const sessionData = leloSession.data[0];
      const startDates = sessionData.schoolYearStartDate;
      const endDates = sessionData.schoolYearEndDate;

      let dateRanges = [];

      // Handle both array format (new) and string format (old)
      if (Array.isArray(startDates) && Array.isArray(endDates)) {
        // New format: Multiple date ranges
        dateRanges = startDates.map((start, index) => ({
          startDate: start.date,
          endDate: endDates[index].date
        }));
      } else if (typeof startDates === "string" && typeof endDates === "string") {
        // Old format: Single date range
        dateRanges = [{
          startDate: startDates,
          endDate: endDates
        }];
      } else {
        throw new Error("Invalid date format in session data");
      }

      // Array to store all generated PDFs
      const generatedPdfs = [];

      // Generate PDF for each date range
      for (let i = 0; i < dateRanges.length; i++) {
        const { startDate, endDate } = dateRanges[i];

        // Format date range for this specific PDF
        const [yearStart, monthStart, dayStart] = startDate.split("-");
        const formattedStart = `${monthStart}-${dayStart}-${yearStart}`;
        const [yearEnd, monthEnd, dayEnd] = endDate.split("-");
        const formattedEnd = `${monthEnd}-${dayEnd}-${yearEnd}`;
        const dateRangeText = `${formattedStart} to ${formattedEnd}`;

        // Create a new PDF using the current form data
        const pdfUrl = `${blobEndpoint}/${blobContainer}/Master%20Agreement%20PDF%20Template.pdf?${blobSas}`;
        const existingPdfBytes = await axios.get(pdfUrl, {
          responseType: "arraybuffer",
          withCredentials: false, // Disable credentials for Azure Blob Storage CORS
        });
        const pdfDoc = await PDFDocument.load(existingPdfBytes.data);
        const form = pdfDoc.getForm();

        // Fill in the form fields with current form data
        form.getTextField("Charter").setText(formData.charter || "");

        const firstNameField = form.getTextField("Student First Name");
        firstNameField.setText(formData.firstName || "");
        firstNameField.setFontSize(13);

        const lastNameField = form.getTextField("Student Last Name");
        lastNameField.setText(formData.lastName || "");
        lastNameField.setFontSize(13);

        const gradeLevelField = form.getTextField("Gradelevel");
        gradeLevelField.setText(formData.gradeLevel || "");
        gradeLevelField.setFontSize(13);

        // Fill in course fields
        const courseFields = ["Course 1", "Course 2", "Course 3", "Course 4"];
        courseFields.forEach((field, index) => {
          const courseField = form.getTextField(field);
          courseField.setText(formData.selectedCourseAgreements[index] || "");
          courseField.setFontSize(13);
        });

        form
          .getTextField("Student Signature Name")
          .setText(formData.studentName || "");
        form
          .getTextField("Parent Signature Name")
          .setText(formData.parentName || "");

        form
          .getTextField("Student Birth Date")
          .setText(moment(formData.birthDate).format("MM/DD/YYYY") || "");
        form.getTextField("Phone 1").setText(formData.studentPrimaryPhone || "");
        form.getTextField("Phone 2").setText(formData.pgPrimaryPhone || "");

        const streetField = form.getTextField("Street Address");
        streetField.setText(formData.street || "");
        streetField.setFontSize(13);

        const cityField = form.getTextField("City");
        cityField.setText(formData.city || "");
        cityField.setFontSize(13);

        const stateField = form.getTextField("State");
        stateField.setText(formData.state || "");
        stateField.setFontSize(13);

        const zipField = form.getTextField("Zip");
        zipField.setText(formData.zip || "");
        zipField.setFontSize(13);

        const dateField = form.getTextField("MA_Dates");
        dateField.setText(dateRangeText || "");
        dateField.setFontSize(13);

        form
          .getTextField("Student Signature Date")
          .setText(
            moment(formData.studentSignatureDate).format("MM/DD/YYYY") || ""
          );

        if (formData.pgRelationshipToStudent !== "Self 18+") {
          form
            .getTextField("Parent Signature Date")
            .setText(
              moment(formData.parentSignatureDate).format("MM/DD/YYYY") || ""
            );
        }

        // Add signatures if they exist
        if (formData.studentSignature) {
          const base64Data = formData.studentSignature.replace(
            /^data:image\/png;base64,/,
            ""
          );
          const signatureImageBytes = Uint8Array.from(
            Buffer.from(base64Data, "base64")
          );
          const signatureImage = await pdfDoc.embedPng(signatureImageBytes);
          const signatureImageDims = signatureImage.scale(0.5);
          const page = pdfDoc.getPages()[1];

          const xPosition = 70;
          const yPosition = 590;
          const maxWidth = 400;
          const scaledWidth = Math.min(signatureImageDims.width, maxWidth);
          const scaleFactor = scaledWidth / signatureImageDims.width;
          const scaledHeight = signatureImageDims.height * scaleFactor;

          page.drawImage(signatureImage, {
            x: xPosition,
            y: yPosition,
            width: scaledWidth,
            height: scaledHeight,
          });
        }

        if (formData.parentSignature) {
          const base64Data = formData.parentSignature.replace(
            /^data:image\/png;base64,/,
            ""
          );
          const signatureImageBytes = Uint8Array.from(
            Buffer.from(base64Data, "base64")
          );
          const signatureImage = await pdfDoc.embedPng(signatureImageBytes);
          const signatureImageDims = signatureImage.scale(0.5);
          const page = pdfDoc.getPages()[1];

          const xPosition = 70;
          const yPosition = 470;

          page.drawImage(signatureImage, {
            x: xPosition,
            y: yPosition,
            width: signatureImageDims.width,
            height: signatureImageDims.height,
          });
        }

        // Save and upload the new PDF
        const pdfBytesFilled = await pdfDoc.save();
        const blobServiceClient = new BlobServiceClient(
          `${blobEndpoint}?${blobSas}`
        );
        const containerClient =
          blobServiceClient.getContainerClient(blobContainer);

        const folderName = sanitize(leloSession.data[0].name || "");

        // Format school year start date for filename (MMDDYYYY)
        const schoolYearStartDate = `${monthStart}${dayStart}${yearStart}`;

        // Format: ProfileName_LastFirst_SchoolYearStartDate(MMDDYYYY)_Timestamp.pdf
        // Example: ExpandedLearning2025_PartidaGabriel_07012025_250630_2103.pdf
        const blobName = `${folderName}/${sanitize(
          leloSession.data[0].name || ""
        )}_${sanitize(formData.lastName || "")}${sanitize(
          formData.firstName || ""
        )}_${schoolYearStartDate}_${formatTimestamp()}.pdf`;

        const blockBlobClient = containerClient.getBlockBlobClient(blobName);

        await blockBlobClient.uploadData(pdfBytesFilled, {
          blobHTTPHeaders: { blobContentType: "application/pdf" },
        });

        const newUploadedUrl = blockBlobClient.url.split("?")[0];

        // Store PDF info for database update
        generatedPdfs.push({
          url: newUploadedUrl,
          fileName: blobName.split('/').pop(),
          uploadedAt: new Date(),
          startDate: startDate
        });

        // Log the export
        await axios.post(`${appUrl}/api/dataexport`, {
          user_name: user?.name,
          azure_id: user?.azureID,
          fileName: blobName.split('/').pop(),
          recordCount: 1,
          screen: "Secondary Enrollments Admin Screen",
          exportType: "signed_agreement LeloPdf",
          exportStatus: "success",
        });
      }

      // Update the form data with all generated PDFs
      const updatedData = {
        uploadedPdfs: generatedPdfs,
        uploadedUrl: generatedPdfs[0]?.url || formData.uploadedUrl // Keep backward compatibility
      };
      await updateLeloEntrie(_id, updatedData);

      toast.success(`Successfully generated ${generatedPdfs.length} PDF(s)!`);

      // Reload the page to show updated PDFs
      window.location.reload();

      // Re-enable the button after a short delay
      setTimeout(() => {
        if (regenerateButton) {
          regenerateButton.disabled = false;
          regenerateButton.style.opacity = "1";
        }
      }, 2000);
    } catch (error) {
      console.error("Error regenerating PDF:", error);
      toast.error(`Error regenerating PDF: ${error.message}`);
      // Re-enable the button in case of error
      const regenerateButton = document.querySelector(".btn-llac-dark-green");
      if (regenerateButton) {
        regenerateButton.disabled = false;
        regenerateButton.style.opacity = "1";
      }
    }
  };

  const handleDownload = async () => {
    if (localStorage.token) {
      setAuthToken(localStorage.token);
    }

    // Determine which PDFs to download
    let pdfsToDownload = [];

    if (uploadedPdfs && uploadedPdfs.length > 0) {
      // New format: Multiple PDFs
      pdfsToDownload = uploadedPdfs.map(pdf => ({
        url: pdf.url,
        fileName: pdf.url.substring(pdf.url.lastIndexOf("/") + 1).split("?")[0]
      }));
    } else if (formData.uploadedUrl) {
      // Old format: Single PDF
      pdfsToDownload = [{
        url: formData.uploadedUrl,
        fileName: formData.uploadedUrl.substring(formData.uploadedUrl.lastIndexOf("/") + 1).split("?")[0]
      }];
    }

    // Download each PDF with a slight delay between downloads
    for (let i = 0; i < pdfsToDownload.length; i++) {
      const { url, fileName } = pdfsToDownload[i];

      // Log the export for each file
      await axios.post(`${appUrl}/api/dataexport`, {
        user_name: user?.name,
        azure_id: user?.azureID,
        fileName: fileName,
        recordCount: 1,
        screen: "Secondary Enrollments Admin Screen ",
        exportType: "signed_agreement LeloPdf",
        exportStatus: "success",
      });

      // Construct the full download URL with blobSas
      const downloadUrl = `${url}?${blobSas}`;

      // Fetch the file and download it
      try {
        const response = await fetch(downloadUrl);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(blobUrl);

        // Add a small delay between downloads to prevent browser blocking
        if (i < pdfsToDownload.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 500));
        }
      } catch (err) {
        console.error(`Failed to download file ${fileName}:`, err);
      }
    }
  };

  return (
    <>
      {status !== "Inactive" && showInactiveModal && (
        <ConfirmModal
          title="Inactive?"
          body="Are you sure you want to mark this entry as Inactive?"
          action={handleNotActive}
          setModal={handleCloseModal} // Properly closing modal
          name="InactiveModal"
          redirect="/lelo-forms"
          btnName="Mark as Inactive"
          btnColor="l4l-red"
        />
      )}
      <div className="interest-form">
        <Helmet>
          <meta charSet="utf-8" />
        </Helmet>

        <div
          className="right display-back display-back-style"
          onClick={() => {
            navigate(-1);
          }}
        >
          <FaIcons.FaArrowAltCircleLeft className="back-icon" />
          <h4>Back</h4>
        </div>

        <h1 className="text-center top-title top-title-style">
          {firstName} {lastName}
        </h1>

        <div className="action-buttons-container-style">
          {user &&
            (user.userStatus === "Contributor" ||
              user.userStatus === "Admin" ||
              user.userStatus === "Super Admin") && (
              <div
                onClick={() => handleEditInterest(_id)}
                className="btn btn-llac-dark-green edit-button-style"
                style={{ cursor: 'pointer' }}
              >
                Edit
              </div>
            )}

          <div className="center-buttons-style">
            <ExportPdfButton formData={formData} />
            {status !== "Active" && (
              <>
                {((uploadedPdfs && uploadedPdfs.length > 0) || formData.uploadedUrl) && (
                  <div
                    className="btn btn-llac-dark-green signed-agreement-button-style"
                    onClick={handleDownload}
                    style={{ cursor: 'pointer' }}
                  >
                    Export Signed Agreement{uploadedPdfs && uploadedPdfs.length > 1 ? ` (${uploadedPdfs.length} files)` : ''}
                  </div>
                )}
                <div
                  className="btn btn-llac-dark-green signed-agreement-button-style"
                  onClick={handleRegeneratePdf}
                  style={{ cursor: 'pointer' }}
                >
                  Regenerate Signed Agreement
                </div>
              </>
            )}
          </div>
          {user &&
            (user.userStatus === "Contributor" ||
              user.userStatus === "Admin" ||
              user.userStatus === "Super Admin") && (
              <div
                onClick={() => status !== "Inactive" && setShowInactiveModal(true)}
                className={`btn btn-llac-red ${
                  status === "Inactive" ? "inactive-button-disabled" : "inactive-button-style"
                }`}
                style={{
                  cursor: status === "Inactive" ? 'not-allowed' : 'pointer',
                  opacity: status === "Inactive" ? 0.6 : 1
                }}
              >
                Inactive
              </div>
            )}
        </div>

        <div className="sub-form">
          <h3>Selected Learning Center</h3>
          <div className="sum-item">
            <h4>Site:</h4>
            <p>{learningCenters}</p>
          </div>

          <div className="sum-item">
            <h4>Charter:</h4>
            <p>{charter}</p>
          </div>
          <div className="sum-item">
            <h4>Registration ID:</h4>
            <p>{_uuid}</p>
          </div>
        </div>

        <div className="sub-form">
          <h3>Student Information</h3>
          <div className="sum-item">
            <h4>Previously Enrolled:</h4>
            <p>{hasPreviouslyEnrolled}</p>
          </div>
          <div className="sum-item">
            <h4>First Name:</h4>
            <p>{firstName}</p>
          </div>
          <div className="sum-item">
            <h4>Middle Name:</h4>
            <p>{middleName}</p>
          </div>
          <div className="sum-item">
            <h4>Last Name:</h4>
            <p>{lastName}</p>
          </div>
          <div className="sum-item">
            <h4>Gender:</h4>
            <p>{gender}</p>
          </div>
          <div className="sum-item">
            <h4>Date of Birth:</h4>
            <p>{birthDate ? moment(birthDate).format("MM/DD/YYYY") : "N/A"}</p>
          </div>
          <div className="sum-item">
            <h4>Email:</h4>
            <p>{studentEmail}</p>
          </div>
          <div className="sum-item">
            <h4>Phone:</h4>
            <p>{`${studentPrimaryPhone} (${studentPrimaryPhoneType})`}</p>
          </div>
        </div>

        <div className="sub-form">
          <h3>Parent Information</h3>
          <div className="sum-item">
            <h4>Relationship:</h4>
            <p>{pgRelationshipToStudent}</p>
          </div>
          {pgRelationshipToStudent !== "Self 18+" && (
            <>
              <div className="sum-item">
                <h4>First Name:</h4>
                <p>{pgFirstName}</p>
              </div>
              <div className="sum-item">
                <h4>Last Name:</h4>
                <p>{pgLastName}</p>
              </div>
              <div className="sum-item">
                <h4>Email:</h4>
                <p>{pgPrimaryEmail}</p>
              </div>
              <div className="sum-item">
                <h4>Phone:</h4>
                <p>{`${pgPrimaryPhone} (${pgPrimaryPhoneType})`}</p>
              </div>
            </>
          )}
        </div>

        <div className="sub-form">
          <h3>Physical Address</h3>
          <div className="sum-item">
            <h4>Lives with Parent:</h4>
            <p>{liveWithPg}</p>
          </div>
          <div className="sum-item">
            <h4>Living Status:</h4>
            <p>{livingStatus}</p>
          </div>
          <div className="sum-item">
            <h4>Street:</h4>
            <p>{street}</p>
          </div>
          <div className="sum-item">
            <h4>City:</h4>
            <p>{city}</p>
          </div>
          <div className="sum-item">
            <h4>State:</h4>
            <p>{state}</p>
          </div>
          <div className="sum-item">
            <h4>ZIP:</h4>
            <p>{zip}</p>
          </div>
          <div className="sum-item">
            <h4>County of Residence:</h4>
            <p>{country}</p>
          </div>
          <div className="sum-item">
            <h4>School District of Residence:</h4>
            <p>{district}</p>
          </div>
        </div>
        {isMailingAddressTheSame &&
          (mailingStreet || mailingCity || mailingState || mailingZip) && (
            <div className="sub-form">
              <h3>Mailing Address</h3>
              <div className="sum-item">
                <h4>Mailing Street:</h4>
                <p>{mailingStreet}</p>
              </div>
              <div className="sum-item">
                <h4>Mailing City:</h4>
                <p>{mailingCity}</p>
              </div>
              <div className="sum-item">
                <h4>Mailing State:</h4>
                <p>{mailingState}</p>
              </div>
              <div className="sum-item">
                <h4>Mailing ZIP:</h4>
                <p>{mailingZip}</p>
              </div>
            </div>
          )}

        <div className="sub-form">
          <h3>Registration for Classes</h3>
          <div className="sum-item">
            <h4>Previously Enrolled:</h4>
            <p>{hasPreviouslyEnrolled}</p>
          </div>
          <div className="sum-item">
            <h4>Grade Level:</h4>
            <p>{gradeLevel}</p>
          </div>
          {courses.map((course, idx) => (
            <div key={idx} className="sum-item">
              <div>
                <h4>Course {idx + 1}:</h4>
                <input
                  type="text"
                  name={`course_name_${idx}`}
                  value={course.course_name}
                  disabled
                  className="course-input-style"
                />
              </div>
              <div style={{ marginLeft: "15px" }}>
                <h4>Credits:</h4>
                <input
                  type="text"
                  name={`credits_${idx}`}
                  value={selectedCourseAgreements[idx] || "N/A"}
                  disabled
                  className="course-input-style"
                />
              </div>
            </div>
          ))}
        </div>
        <div className="sub-form">
          <h3>Agreement</h3>
          <div className="sum-item">
            <h4>Student Name:</h4>
            <div>
              <p>{studentName}</p>
            </div>
          </div>
          <div className="sum-item">
            <h4>Student Signature Date:</h4>
            <div>
              <p>
                {studentSignatureDate
                  ? moment(studentSignatureDate).format("MM/DD/YYYY")
                  : "N/A"}
              </p>
            </div>
          </div>

          <div className="sum-item">
            <h4>Student Signature: </h4>
            <div>
              <img
                src={studentSignature}
                alt="Student Signature"
                className="signature-image-style"
              />
            </div>
          </div>
          {pgRelationshipToStudent !== "Self 18+" && (
            <>
              <div className="sum-item">
                <h4>Parent Name:</h4>
                <div>
                  <p>{parentName}</p>
                </div>
              </div>
              <div className="sum-item">
                <h4>Parent Signature Date:</h4>
                <div>
                  <p>
                    {parentSignatureDate
                      ? moment(parentSignatureDate).format("MM/DD/YYYY")
                      : "N/A"}
                  </p>
                </div>
              </div>

              <div className="sum-item">
                <h4>Parent Signature: </h4>
                <div>
                  <img
                    src={parentSignature}
                    alt="Parent Signature"
                    className="signature-image-style"
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default LeloForm;
